import utils from '@eitje/utils'

export const buildRowData = (taxonomy, data) =>
	_.flatMap(taxonomy, (fields, sectionKey) => {
		const header = !Array.isArray(taxonomy) &&
			sectionKey && {
				description: sectionKey,
				rowType: 'subheader',
				typeId: 'subheader',
			}

		const rows = _.map(_.castArray(fields), field => {
			const {field: fieldName, t, relatedKeys, rowStyle, ...rest} = field
			const relatedValue = relatedKeys && data[relatedKeys]

			return {
				...rest,
				description: t || fieldName,
				value: data[fieldName],
				ids: relatedKeys && utils.alwaysArray(relatedValue),
				typeId: rowStyle || 'default',
			}
		})

		return header ? [header, ...rows] : rows
	})
